import React from 'react';
import { Redirect as ReactRedirect } from 'react-router-dom';
import { BasePath, pagePathToPathString } from 'services/base/page_path';
import { useAccountsDomain } from 'services/accounts/accounts_domain';

export const Redirect = () => {
  const accounts = useAccountsDomain();

  const user = accounts.user;
  const pangolin = accounts.pangolins.getDefault();

  if (user == null || pangolin == null) {
    return (
      <ReactRedirect to={pagePathToPathString({
        kind: BasePath.INTRO,
      })}/>
    );
  } else {
    return (
      <ReactRedirect to={pagePathToPathString({
        kind: BasePath.HOME,
        pangolinID: pangolin.id,
      })}/>
    );
  }
};
